import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-communication-shield-thunder-icon',
  templateUrl: './communication-shield-thunder.component.html'
})
export class CommunicationShieldThunderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
